import admin from '@/router/middlewares/admin';

export const Index = r => require.ensure([], () => r(require('./index')), 'manufacturers-bundle');

export default [
  {
    path: 'manufacturers',
    name: 'manufacturers',
    component: Index,
    meta: {
      middleware: [admin]
    }
  }
];
